import React, { useState, useEffect } from 'react';
import styles from '../styles/Hero.module.css';

const Hero: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className={styles.hero} id="home">
      <div
        className={`${styles.content} ${loaded ? styles.visible : ''}`}
      >
        <h1 className={styles.heading}>
          hi .ᐟ i'm {' '}
          <span className={styles.highlight}>amanda zhu.</span>
          {' '} design with{' '}
          <em>heart</em> and build for <em>connection</em> ⊹ ࣪
        </h1>

        <p className={styles.sub}>
          <span className={styles.subPrefix}>ui/ux | </span>
          𓄲 toronto | everything is play ツ
        </p>
      </div>
    </section>
  );
};

export default Hero;
